import { render } from "./Tutos.vue?vue&type=template&id=9d491512"
import script from "./Tutos.vue?vue&type=script&lang=js"
export * from "./Tutos.vue?vue&type=script&lang=js"

import "./Tutos.vue?vue&type=style&index=0&id=9d491512&lang=scss"

import exportComponent from "/var/www/vhosts/universalmusic.fr/sites/crm/www/frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__